import React from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';

import {
  refreshSession
} from '../../modules/session';

import { Modal, Form, Button } from 'semantic-ui-react';
import VerificationForm from '../authentication/verificationForm';
import RecoveryForm from '../authentication/recoveryForm';

import config from '../../constants';
import { verificationVariant } from '../../constants/multiFactorAuth';
import { grecaptcha } from '../../helpers/grecaptcha';
import { I18n } from 'react-redux-i18n';
import LocalStorage from '../../helpers/localStorageHelper';

// TODO: Once all backend MFA flows use v3 two-phase model, this modal
// can be removed. It currently only handles 403 re-verification for
// non-session API calls (e.g. sensitive operations requiring OTP).
class SessionVerificationModalContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      variant: verificationVariant.authCode,
      disabled: false,
      authCode: null,
      recoveryCode: null
    };
  }

  handleValueChange = (path, value) => {
    if (path.endsWith('.authCode')) {
      this.setState({ authCode: value });
    } else if (path.endsWith('.recoveryCode')) {
      this.setState({ recoveryCode: value });
    }
  };

  handleVerifyButtonClick = () => {
    if (this.state.disabled === false) {
      this.setState({ disabled: true });
    }
    this.handleSessionRefresh();
  };

  handleSessionRefresh = () => {
    const session = LocalStorage.getSession();

    if (session && session.refresh) {
      const tokenCallback = (token) =>
        this.props.refreshSession(
          session.account.id,
          session.refresh,
          token
        );
      grecaptcha(tokenCallback, 'SessionRefresh');
    }
  };

  handleVerificationVariantChange = (value) => {
    if (this.state.variant !== value) {
      this.setState({
        variant: value,
        authCode: null,
        recoveryCode: null
      });
    }
  };

  render() {
    // If MFA two-phase flow was triggered, yield to the /verify-mfa route
    if (this.props.mfaPending) {
      return <Navigate to="/verify-mfa" replace />;
    }

    if (this.props.show) {
      return (
        <Modal
          className="session-verification-modal"
          size="tiny"
          dimmer="blurring"
          open
        >
          <Modal.Content>
            <Form onSubmit={this.handleVerifyButtonClick}>
              <div className="verification-form">
                <h1 className="variant-title">{I18n.t('authentication.mfa.heading')}</h1>
                <div className="variant-description">
                  {I18n.t('authentication.mfa.description')}
                </div>
                <br />
                {this.state.variant === verificationVariant.authCode && (
                  <VerificationForm
                    path="sessionVerification"
                    handleValueChange={this.handleValueChange}
                    handleVerificationVariantChange={
                      this.handleVerificationVariantChange
                    }
                  />
                )}
                {this.state.variant === verificationVariant.recoveryCode && (
                  <RecoveryForm
                    path="sessionVerification"
                    value={this.state.recoveryCode}
                    handleValueChange={this.handleValueChange}
                    handleVerificationVariantChange={
                      this.handleVerificationVariantChange
                    }
                  />
                )}
                <div className="verification-action-button">
                  <Button
                    primary
                    loading={this.props.isSessionLoading}
                    disabled={
                      this.props.isSessionLoading || this.state.disabled
                    }
                  >
                    {I18n.t('authentication.mfa.verify')}
                  </Button>
                </div>
                <br />
                <div className="verification-contact-us">
                  {I18n.t('authentication.mfa.needHelp')}{' '}
                  <a href={config.contactUsUrl}>{I18n.t('authentication.mfa.supportTeam')}</a>
                </div>
              </div>
            </Form>
          </Modal.Content>
        </Modal>
      );
    }
    return <div></div>;
  }
}

const mapState = ({ session }) => {
  return {
    isSessionLoading: session.processing,
    mfaPending: session.mfaPending && !!session.pendingSessionToken
  };
};

const mapDispatch = (dispatch) => {
  return {
    refreshSession(accountId, refreshCode, verificationToken) {
      dispatch(refreshSession(accountId, refreshCode, verificationToken));
    }
  };
};

const SessionVerificationModal = connect(
  mapState,
  mapDispatch
)(SessionVerificationModalContainer);
export default SessionVerificationModal;
